export default __webpack_public_path__ + "static/media/logo.1319b4e2.png";